import { render, staticRenderFns } from "./TruncatedReadMoreTextContainer.vue?vue&type=template&id=1c71cad0&scoped=true&"
import script from "./TruncatedReadMoreTextContainer.vue?vue&type=script&lang=ts&"
export * from "./TruncatedReadMoreTextContainer.vue?vue&type=script&lang=ts&"
import style0 from "./TruncatedReadMoreTextContainer.vue?vue&type=style&index=0&id=1c71cad0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c71cad0",
  null
  
)

export default component.exports